import React, { ComponentProps } from 'react';
import classNames from 'classnames';
import Icon from '@/components/ui/Icon';
import { Size } from '@/types/enums';

import styles from './Label.module.css';

export enum LabelType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  EXPIRED = 'EXPIRED',
  ACTIVATE_SUBSCRIPTION = 'ACTIVATE_SUBSCRIPTION',
}

type LabelProps = Partial<Pick<ComponentProps<typeof Icon>, 'size' | 'iconName'>>
  & {
  type?: LabelType,
  onClick?: React.MouseEventHandler<HTMLDivElement>,
};

const labelTypeStyles: Record<LabelType, string> = {
  ACTIVATE_SUBSCRIPTION: styles['label--activate-subscription'],
  EXPIRED: styles['label--expired'],
  PRIMARY: styles['label--primary'],
  SECONDARY: styles['label--secondary'],
};

export default function Label(
  {
    children,
    type = LabelType.PRIMARY,
    onClick,
    iconName,
    size = Size.SMALL,
  }: React.PropsWithChildren<LabelProps>,
): React.ReactElement {
  return (
    <div
      onClick={onClick}
      className={classNames([
        styles.label,
        labelTypeStyles[type],
        { [styles['label--with-icon']]: !!iconName },
      ])}
    >
      {iconName && <Icon iconName={iconName} size={size} />}
      <span className={styles.label__text}>{children}</span>
    </div>
  );
}
